import * as z from 'zod'

import { TaskLocation } from '../TaskLocationPopout'

export interface CreateTaskInitialData {
  fromLocation?: TaskLocation | null
  toLocation?: TaskLocation | null
  fromDatetime?: string
  toDatetime?: string
}

export interface CreateTaskModalProps {
  isActive: boolean
  onClose: () => void
  onTaskCreated?: () => void
  initialData?: CreateTaskInitialData
}

export enum TaskStatus {
  REQUESTED = 'REQUESTED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  DELAYED = 'DELAYED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface StopErrors {
  location?: string
  datetime?: string
  locationWarning?: string
}

const REFERENCE_VALID_REGEX =
  /^[A-Za-z0-9$#@+\-\\/]{1}[A-Za-z0-9$#@+\- \\/]*[A-Za-z0-9$#@+\-\\/]{1}$/

export const createTaskSchema = z.object({
  reference: z
    .string()
    .trim()
    .min(3, 'Task reference is required')
    .regex(
      REFERENCE_VALID_REGEX,
      'Only letters, numbers, slashes, dashes, spaces, $, #, @ and + are allowed.',
    ),
  description: z.string().optional(),
})

export type CreateTaskFormData = z.infer<typeof createTaskSchema>

export const FORM_DEFAULTS: Partial<CreateTaskFormData> = {
  reference: '',
  description: '',
} as const
